import { ChangeDetectorRef, Component, Input, Output, OnChanges, EventEmitter, SimpleChanges, inject, ViewChild, TemplateRef } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { RestClient, User } from "../../Api/DcoApi/Client/RestClient";
import { Observable } from "rxjs/internal/Observable";
import { Auftrag } from "../../Api/DcoApi/Auftraege";
import { DateSelect } from "./DateSelect";
import { Patient } from "../../Api/DcoApi/Patient";
import { Ruekholung } from "../../Api/DcoApi/AktenEintraege/Ruekholung";
import { ToastService } from "../Services/Toasts/ToastService";
import { IsSpezialUserDirective, IsWelcomeCallDirective,IsManagementDirective } from "../../Admin/AdminGuard";


@Component({
  selector: 'Rueckabwicklung',
  templateUrl: './Rueckabwicklung.html',
  styleUrl: './Rueckabwicklung.css',
  imports: [FormsModule, DateSelect,IsSpezialUserDirective],
  standalone: true,
})
export class Rueckabwicklung implements OnChanges  {
  toastService: ToastService;
  constructor(private cdr: ChangeDetectorRef) {
    this.toastService = inject(ToastService);
}
  ngOnChanges(changes: SimpleChanges): void {
    if (this.Auftrag != null && this.Auftrag != undefined) {
      if (this.Auftrag.ruekholung == null || this.Auftrag.ruekholung == undefined)
        this.Auftrag.ruekholung = {} as Ruekholung;
    }
    }
  public ApiUser = User;
  Client: RestClient = new RestClient();
  @Input() Auftrag: Auftrag | null | undefined = null;
  @Output() AuftragChange = new EventEmitter<Auftrag | null>();
  @Input() Patient: Patient | null | undefined = null;

  ShowIfIsNotNull(date: Date | null | undefined): boolean {
    return true;// date != null && date != undefined;
  }

  async Save() {
    var auf = await this.Client.Post<Auftrag, Ruekholung>(`/Backend/Api/V2/Akte/${this.Patient?.versicherungsnummer}/Auftrag/${this.Auftrag?.key}/Ruekholung`, this.Auftrag?.ruekholung ?? {} as Ruekholung);
    this.AuftragChange.emit(auf);
    this.Auftrag = auf;
    this.toastService.show({ template: this.successTpl, classname: 'bg-success text-light show', delay: 10000 });
  }

  @ViewChild('successTpl') public successTpl!: TemplateRef<any>;
}
